import React from 'react';

import './Clock.scss';

interface Props {
  untilDate: Date;
  onFinish?: () => void
}
interface State {
  remaining: number;
}
class Clock extends React.Component<Props, State> {
   
  constructor(props) {
    super(props)

    this.state = {
      remaining: this.calculate(props.untilDate)
    }
  }

  ref: any = null
  async componentDidMount() {
    this.ref = setInterval(() => {
      const { onFinish } = this.props
      const { remaining } = this.state

      if (remaining === 0) {
        if (onFinish)
          onFinish() 
        clearInterval(this.ref)
      } else 
        this.setState({ remaining: remaining - 1 })
    }, 1000)
  }

  calculate(untilDate: Date) {
    const end = untilDate.getTime()
    const now = new Date().getTime()
    const delta = end - now
    if (delta < 0)
      return 0
    return delta / 1000
  }

  format() {
    const total = this.state.remaining
    let hours: any   = Math.floor(total / 3600);
    let minutes: any = Math.floor((total - (hours * 3600)) / 60);
    let seconds: any = total - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    return hours+':'+minutes+':'+ Number(seconds).toFixed(0);
  }

  componendWillUnmount() {
    if (this.ref)
      clearInterval(this.ref)
  }

  render() {
    return (
      <div className="clock-container">
        {this.format()}
      </div>
    );
  }
}

export default Clock
